
import { COLLECTION_PAGE_QUERY, PAGE_TYPE } from "./-index.query";
import {
  seoMixin,
  pageMixin,
  itemListSchemaMixin,
  faqSchemaMixin,
} from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin, itemListSchemaMixin, faqSchemaMixin],

  provide() {
    return {
      // Allow slices to add schemas to page
      addPageSchema: schema => {
        if (!this.sliceSchemas.includes(schema)) {
          this.sliceSchemas.push(schema);
        }
      },
    };
  },

  async asyncData({ app, params: { handle: uid }, redirect }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: COLLECTION_PAGE_QUERY,
      variables: { uid, lazy: false },
    });

    if ((data?.slices ?? []).length == 0) {
      return redirect(301, `/collections/${uid}/products`);
    }

    const plpBanner = data.plp_banner_link;
    const bannerConfig = plpBanner?.display_banners
      ? {
          productTileBanners: [
            { image: plpBanner.image_1, image_link: plpBanner.image_1_link },
            { image: plpBanner.image_2, image_link: plpBanner.image_2_link },
          ].filter(({ image }) => image),
          heroBanner: {
            image: plpBanner.image,
            image_link: plpBanner.image_link,
          },
        }
      : null;

    return {
      uid,
      pageType: PAGE_TYPE,
      slices: data.slices,
      title: data.title,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      context: { collection: data?.collection, bannerConfig },
    };
  },

  data() {
    return {
      sliceSchemas: [],
    };
  },

  computed: {
    additionalScripts() {
      const itemList = this.itemListSchemaScript
        ? [this.itemListSchemaScript]
        : [];
      return [
        ...itemList,
        ...this.faqSchemaScripts,
        ...this.sliceSchemas,
      ].filter(Boolean);
    },
  },
};
